import { Mail, Phone } from 'lucide-react'
import Image from 'next/image'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { AdminContactFragment } from '../../../../../lib/graphql'

const AdminContact = ({ admin }: { admin: AdminContactFragment }) => {
  return (
    <div className='flex h-full items-center gap-2.5 rounded-lg bg-grey-300 py-1.5 pl-3 pr-4'>
      {admin.profilePicture && (
        <Image
          src={admin.profilePicture}
          alt='logo'
          width={40}
          height={40}
          style={{ objectFit: 'cover', borderRadius: '100%' }}
        />
      )}
      <div className='flex flex-col'>
        <h3 className='text-sm'>
          <FormattedMessage
            id='ui.AdminContact.contactAdvisor'
            defaultMessage='Contacter mon conseiller'
          />{' '}
          <span className='font-bold'>{admin.firstname}</span>
        </h3>
        <div className='flex gap-4 text-sm'>
          {admin.phoneNumber && (
            <div className='flex items-center gap-2'>
              <Phone fill='black' color='white' size={15} />
              <a href={`tel:${admin.phoneNumber}`}>{admin.phoneNumber}</a>
            </div>
          )}
          <div className='flex items-center gap-2'>
            <Mail fill='black' color='white' size={15} />
            <a href={`mailto:${admin.email}`}>{admin.email}</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminContact
